import SectionCard from "../components/SectionCard";
import KpiCard from "../components/KpiCard";
import FunnelChart from "../components/charts/FunnelChart";
import AreaChart from "../components/charts/AreaChart";
import BarChart from "../components/charts/BarChart";
import { farmaciaData } from "../mocks/data";
import { Pill, PackageCheck, RotateCcw, AlertCircle } from "lucide-react";
import { formatNum, formatPct } from "../lib/constants";

export default function Farmacia() {
  const d = farmaciaData;
  const flujoFunnel = d.flujo.map((f, i) => ({
    ambito: f.etapa,
    pacientes: f.pacientes,
    pct_entrada: f.pct,
    pct_anterior: i === 0 ? 100 : (f.pacientes / d.flujo[i - 1].pacientes) * 100,
    color: ["#7C3AED", "#6366F1", "#3B82F6", "#06B6D4", "#EF4444"][i],
  }));

  return (
    <div className="space-y-6" data-testid="farmacia-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Farmacia y Medicamentos</h1>
        <p className="text-sm text-slate-500 mt-1">Flujo cruzado TrakCare ↔ SAP: receta → validación → dispensación → administración → devolución</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <KpiCard testid="kpi-recetas" label="Recetas emitidas" value={formatNum(d.recetas_emitidas)} icon={Pill} accent="violet" delta={3.5} />
        <KpiCard testid="kpi-dispensaciones" label="Dispensaciones" value={formatNum(d.dispensaciones)} icon={PackageCheck} accent="blue" delta={2.8} />
        <KpiCard testid="kpi-devoluciones" label="Devoluciones" value={formatNum(d.devoluciones)} icon={RotateCcw} accent="rose" delta={0.2} />
        <KpiCard testid="kpi-tasa-dev" label="Tasa de devolución" value={formatPct(d.tasa_devolucion)} icon={AlertCircle} accent="amber" delta={0.2} />
      </div>

      <div className="rounded-2xl border border-amber-200 bg-gradient-to-r from-amber-50 to-white p-5 flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <div className="font-semibold text-slate-900">Alerta: incremento en tasa de devolución</div>
          <div className="text-sm text-slate-600 mt-1">
            La tasa de devolución pasó de <b>{formatPct(d.tasa_devolucion_pre)}</b> (pre TrakCare) a <b>{formatPct(d.tasa_devolucion)}</b> actual.
            Requiere análisis de procesos de prescripción y validación.
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SectionCard title="Flujo TC ↔ SAP" subtitle="Prescripción → dispensación → devolución" testid="flujo-farmacia">
          <FunnelChart data={flujoFunnel} height={340} />
        </SectionCard>

        <SectionCard title="Evolución tasa de devolución" subtitle="Últimos 8 meses" testid="evolucion-devolucion">
          <AreaChart
            categories={d.tendencia_devolucion.map((t) => t.mes)}
            series={[{ name: "Tasa devolución %", data: d.tendencia_devolucion.map((t) => t.tasa) }]}
            colors={["#EF4444"]}
            height={340}
          />
        </SectionCard>
      </div>

      <SectionCard title="Top medicamentos con mayor devolución" subtitle="Oportunidad de mejora en prescripción" testid="top-meds">
        <BarChart
          categories={d.top_devueltos.map((m) => m.nombre)}
          series={[{ name: "Devoluciones", data: d.top_devueltos.map((m) => m.devoluciones) }]}
          colors={["#EF4444", "#F97316", "#F59E0B", "#EC4899", "#D946EF", "#7C3AED", "#6366F1", "#3B82F6"]}
          horizontal
          distributed
          height={380}
        />
      </SectionCard>
    </div>
  );
}
